(function () {
  // Nejungiam hover ant touch device (telefonai)
  if (window.matchMedia('(hover: none)').matches) return;

  function initThumbnailHover() {
    // Tik thumbnail mygtukai. (Ritual temoje dažniausiai tokia klasė)
    // Plius pridedu fallback'us jei klasė kitokia.
    const thumbSelector =
      '.slideshow-controls__thumbnail, [thumbnails] .slideshow-controls__thumbnail, .media-gallery__thumbnails button, .media-gallery__thumbnails a';

    const thumbs = document.querySelectorAll(thumbSelector);
    if (!thumbs.length) return;

    thumbs.forEach((thumb) => {
      // apsauga kad nepririštų kelis kartus
      if (thumb.dataset.hoverBound === '1') return;
      thumb.dataset.hoverBound = '1';

      thumb.addEventListener(
        'mouseenter',
        () => {
          // Jeigu thumbnail jau active – nieko nedarom
          if (
            thumb.getAttribute('aria-current') === 'true' ||
            thumb.getAttribute('aria-selected') === 'true' ||
            thumb.classList.contains('is-active')
          ) {
            return;
          }

          // Svarbiausia: spaudžiam BŪTENT thumbnail'ą (ne didelę foto)
          // Tai perjungia pagrindinę foto, bet neatidaro zoom dialog.
          thumb.click();
        },
        { passive: true }
      );
    });
  }

  document.addEventListener('DOMContentLoaded', initThumbnailHover);
  document.addEventListener('shopify:section:load', initThumbnailHover);
})();